// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__IJmup","row":"ProcedureTreatmentSummary_row__2LB59"};